// @flow

/**
 * Module dependencies.
 */

import { branch } from 'core/utils/branch';
import { get, isNil, isUndefined, kebabCase } from 'lodash';

/**
 * Set prop style.
 */

export const setPropStyle = (propName: string, cssProperty?: string) => (props: any) => {
  const cssValue = get(props, propName, false);
  const propperty = branch(!isUndefined(cssProperty), cssProperty, kebabCase(propName));
  const isValid = cssValue !== false && !isNil(cssValue);

  return branch(isValid, `${propperty}: ${cssValue};`, '');
};



// WEBPACK FOOTER //
// ../src/client/core/utils/styles.js